import React from "react";
import { IClefProps } from "./interfaces";

export default ({ height, marginTop }: IClefProps) => (
    <svg style={{ marginTop }} height={height} viewBox="0 0 46.7 52">
        <path d="M13,44c8.7-7.8,14.1-18.1,14.1-27.4,0-7.5-4.2-13.1-11-13.1-4.8,0-10,4-10,8.1,0,.6.1.9.4.9a7.2,7.2,0,0,1,4.1-1c2.6,0,4.1,2.3,4.1,4.9s-3,5.1-5.7,5.1-6.2-3.1-6.2-7.7C2.8,6.9,9.6,1.5,17.2,1.5c13.9,0,16.2,9.3,16.2,17.1,0,4.9-.9,8.4-5.4,15.6C22.3,43.4,9.8,50.5,4.9,50.5c-1.2,0-1.8-1.1-.6-1.5S10.7,46,13,44ZM41.6,6.2a3.1,3.1,0,0,1,3,2.9h0a3.1,3.1,0,0,1-2.9,3h-.1a3.1,3.1,0,0,1-3-2.9h0a3.1,3.1,0,0,1,3-3Zm0,14.7a3,3,0,1,1-3,3h0a3.1,3.1,0,0,1,3-3Z" />
    </svg>
);
